import { createFileRoute } from "@tanstack/react-router";

import { AdminOverviewTab } from "@/features/billing";

export const Route = createFileRoute(
  "/_auth/_app-shell/billing/accounts/$projectId/overview",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId } = Route.useParams();

  return <AdminOverviewTab projectId={Number(projectId)} />;
}
